import { createApp } from 'vue'
import App from './App.vue'
import mitt from 'mitt'
import Maska from 'maska'
import router from './router'
import VueMobileDetection from 'vue-mobile-detection'
import moment from 'moment';
import {createPinia} from 'pinia'

//#region Import PrimeVue
import PrimeVue from 'primevue/config';
import Textarea from 'primevue/textarea';
import InputSwitch from 'primevue/inputswitch';
import Message from 'primevue/message';
import ScrollTop from 'primevue/scrolltop';

import 'primevue/resources/themes/lara-light-blue/theme.css' //theme
import 'primevue/resources/primevue.min.css'                 //core css
import 'primeicons/primeicons.css'                           //icons
import '/node_modules/primeflex/primeflex.css'
//#endregion

const emitter = mitt()

const app = createApp(App)

app.config.globalProperties.emitter = emitter;
app.config.globalProperties.$moment = moment;
app.config.globalProperties.$moment.locale('pt-br');

app.use(router)
app.use(VueMobileDetection)
app.use(Maska)
app.use(PrimeVue, {
    ripple: true,
    locale: {
        startsWith: 'Starts with',
        contains: 'Contains',
        notContains: 'Not contains',
        endsWith: 'Ends with',
        equals: 'Equals',
        notEquals: 'Not equals',
        noFilter: 'No Filter',
        lt: 'Less than',
        lte: 'Less than or equal to',
        gt: 'Greater than',
        gte: 'Greater than or equal to',
        dateIs: 'Date is',
        dateIsNot: 'Date is not',
        dateBefore: 'Date is before',
        dateAfter: 'Date is after',
        clear: 'Clear',
        apply: 'Apply',
        matchAll: 'Match All',
        matchAny: 'Match Any',
        addRule: 'Add Rule',
        removeRule: 'Remove Rule',
        accept: 'Yes',
        reject: 'No',
        choose: 'Choose',
        upload: 'Upload',
        cancel: 'Cancel',
        dayNames: ["Domingo", "Segunda", "Terça", "Quarta", "Quinta", "Sexta", "Sábado"],
        dayNamesShort: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"],
        dayNamesMin: ["Do","Se","Te","Qua","Qui","Se","Sa"],
        monthNames: ["Janeiro","Fevereiro","Março","Abril","Maio","Junho","Julho","Agosto","Setembro","Outubro","Novembro","Dezembro"],
        monthNamesShort: ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun","Jul", "Ago", "Set", "Out", "Nov", "Dez"],
        today: 'Today',
        weekHeader: 'Wk',
        firstDayOfWeek: 0,
        dateFormat: 'dd/mm/yy',
        weak: 'Weak',
        medium: 'Medium',
        strong: 'Strong',
        passwordPrompt: 'Enter a password',
        emptyFilterMessage: 'No results found',
        emptyMessage: 'No available options'
    }     
});
app.use(createPinia())

//#region Componentes PrimeVue
app.component('TextArea', Textarea);
app.component('InputSwitch', InputSwitch);
app.component('MessagePrime', Message);
app.component('ScrollTop', ScrollTop);
//#endregion

app.mount('#app')
